import React from 'react';
import {
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    FormHelperText
} from '@material-ui/core';

export default function AgeConfirmation({
    isOver16,
    selectIsOver16,
    selectIsUnder16,
    hasError
}) {
    return (
        <div data-testid="age-confirmation">
            <div>
                <FormControl>
                    <FormLabel>Please confirm your age</FormLabel>
                    <RadioGroup
                        name="controlled-radio-buttons-group"
                        value="Age Confirmation"
                        className="terms-of-use-radio-group"
                    >
                        <FormControlLabel
                            control={
                                <Radio
                                    onChange={selectIsOver16}
                                    checked={isOver16 !== null && isOver16}
                                    data-testid="I am 16 years or older"
                                />
                            }
                            label="I am 16 years or older"
                        />
                        <FormControlLabel
                            control={
                                <Radio
                                    onChange={selectIsUnder16}
                                    checked={isOver16 !== null && !isOver16}
                                    data-testid="I am younger than 16 years old"
                                />
                            }
                            label="I am younger than 16 years old"
                        />
                    </RadioGroup>
                </FormControl>
            </div>
            {hasError && (
                <FormHelperText error>
                    Please indicate whether you are older or younger than 16
                </FormHelperText>
            )}
        </div>
    );
}
